export default {
  setSettingList (state, payload) {
    state.settingList = payload
  }
}
